import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'
import ImageGallery from '@/utils/gallery_list'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET, BAIDU_TRANSLATE_API_KEY } from '@/utils/secretCrypto'
/**
 * @description:这是一个Flux通用美甲的执行算法
 * @param {string} galleryname
 * @param {string} positive
 * @return {Array} imageList
 */

function fluxImageGen(galleryname, positive, genParam, progressCallback) {
  return new Promise((resolve, reject) => {
    const imageList = []
    let num = null
    let ImageList = null
    if (galleryname === 'cateyes') {
      num = Math.floor(Math.random() * 108) + 1
      ImageList = ImageGallery.cateyesGallery()
    }
    if (galleryname === 'black_hands') {
      num = Math.floor(Math.random() * 50) + 1
      ImageList = ImageGallery.balckhandsGallery()
    }
    if (galleryname === 'common_hands') {
      num = Math.floor(Math.random() * 767) + 1
      ImageList = ImageGallery.commonflux()
    }
    const image2imagepath = ImageList[num]

    const seed = Math.floor(Math.random() * 100000000000000)
    const filename_1 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_2 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_3 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_4 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const promptData = {
      1: {
        inputs: {
          seed: seed
        },
        class_type: 'easy seed',
        _meta: {
          title: 'EasySeed'
        }
      },
      2: {
        inputs: {
          samples: [
            '11',
            0
          ],
          vae: [
            '10',
            0
          ]
        },
        class_type: 'VAEDecode',
        _meta: {
          title: 'VAE Decode'
        }
      },
      4: {
        inputs: {
          X: [
            '1',
            0
          ],
          tips: '整数变量X'
        },
        class_type: 'Math_X变量值',
        _meta: {
          title: 'Math_X变量值'
        }
      },
      9: {
        inputs: {
          text: [
            '22',
            0
          ],
          clip: [
            '14',
            0
          ]
        },
        class_type: 'CLIPTextEncode',
        _meta: {
          title: 'CLIP Text Encode (Prompt)'
        }
      },
      10: {
        inputs: {
          vae_name: 'FLUX.1-vae.sft'
        },
        class_type: 'VAELoader',
        _meta: {
          title: 'Load VAE'
        }
      },
      11: {
        inputs: {
          seed: [
            '4',
            0
          ],
          sampler: 'euler',
          scheduler: 'simple',
          steps: genParam.steps,
          guidance: genParam.guidance,
          max_shift: '',
          base_shift: '',
          denoise: 0.5,
          model: [
            '13',
            0
          ],
          conditioning: [
            '9',
            0
          ],
          latent_image: [
            '32',
            0
          ]
        },
        class_type: 'FluxSamplerParams+',
        _meta: {
          title: '🔧 Flux Sampler Parameters'
        }
      },
      12: {
        inputs: {
          model_path: 'Nunchaku/svdq-int4_r32-flux.1-krea-dev.safetensors',
          cache_threshold: 0.12,
          attention: 'nunchaku-fp16',
          cpu_offload: 'auto',
          device_id: 0,
          data_type: 'bfloat16',
          i2f_mode: 'enabled'
        },
        class_type: 'NunchakuFluxDiTLoader',
        _meta: {
          title: 'Nunchaku FLUX DiT Loader'
        }
      },
      13: {
        inputs: {
          model: [
            '18',
            0
          ]
        },
        class_type: 'DifferentialDiffusion',
        _meta: {
          title: 'Differential Diffusion'
        }
      },
      14: {
        inputs: {
          model_type: 'flux',
          text_encoder1: 'clip_l.safetensors',
          text_encoder2: 't5xxl_fp8_e4m3fn.safetensors',
          t5_min_length: 512,
          use_4bit_t5: 'disable',
          int4_model: 'none'
        },
        class_type: 'NunchakuTextEncoderLoader',
        _meta: {
          title: 'Nunchaku Text Encoder Loader (Deprecated)'
        }
      },
      18: {
        inputs: {
          lora_name: 'Flux_MJ/Flux_CatEyesV1.0_rank16_bf16.safetensors',
          strength_model: 0.85,
          model: [
            '12',
            0
          ]
        },
        class_type: 'LoraLoaderModelOnly',
        _meta: {
          title: 'LoraLoaderModelOnly'
        }
      },
      22: {
        inputs: {
          text: [
            '56',
            0
          ]
        },
        class_type: 'Nodepad_啊程记事本',
        _meta: {
          title: 'Nodepad_啊程记事本'
        }
      },
      23: {
        inputs: {
          filename_prefix: 'ComfyUI',
          images: [
            '2',
            0
          ]
        },
        class_type: 'SaveImage',
        _meta: {
          title: '图生图'
        }
      },
      29: {
        inputs: {
          image: 'example.png'
        },
        class_type: 'LoadImage',
        _meta: {
          title: 'Load Image'
        }
      },
      30: {
        inputs: {
          pixels: [
            '38',
            0
          ],
          vae: [
            '10',
            0
          ]
        },
        class_type: 'VAEEncode',
        _meta: {
          title: 'VAE Encode'
        }
      },
      31: {
        inputs: {
          upscale_method: 'nearest-exact',
          width: genParam.absWidth,
          height: genParam.absWidth,
          crop: 'center',
          samples: [
            '30',
            0
          ]
        },
        class_type: 'LatentUpscale',
        _meta: {
          title: 'Upscale Latent'
        }
      },
      32: {
        inputs: {
          amount: 4,
          samples: [
            '31',
            0
          ]
        },
        class_type: 'RepeatLatentBatch',
        _meta: {
          title: 'Repeat Latent Batch'
        }
      },
      37: {
        inputs: {
          image_url: image2imagepath
        },
        class_type: 'AC_从URL加载图像',
        _meta: {
          title: 'AC_从URL加载图像'
        }
      },
      38: {
        inputs: {
          boolean: false,
          on_true: [
            '29',
            0
          ],
          on_false: [
            '37',
            0
          ]
        },
        class_type: 'easy ifElse',
        _meta: {
          title: 'If else'
        }
      },
      41: {
        inputs: {
          images: [
            '2',
            0
          ]
        },
        class_type: 'ImageListToImageBatch',
        _meta: {
          title: 'Image List to Image Batch'
        }
      },
      44: {
        inputs: {
          index: 0,
          any: [
            '41',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      45: {
        inputs: {
          index: 1,
          any: [
            '41',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      46: {
        inputs: {
          index: 2,
          any: [
            '41',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      47: {
        inputs: {
          index: 3,
          any: [
            '41',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      48: {
        inputs: {
          filename: filename_1,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '44',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      49: {
        inputs: {
          filename: filename_2,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '45',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      50: {
        inputs: {
          filename: filename_3,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '46',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      51: {
        inputs: {
          filename: filename_4,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '47',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      54: {
        inputs: {
          text: positive
        },
        class_type: 'Nodepad_啊程记事本',
        _meta: {
          title: 'Nodepad_啊程记事本'
        }
      },
      55: {
        inputs: {
          text: positive,
          translate_from: 'zh',
          translate_to: 'en',
          APIID: '20250612002379955',
          APIKEY: BAIDU_TRANSLATE_API_KEY
        },
        class_type: 'AC_百度翻译',
        _meta: {
          title: 'AC_百度翻译'
        }
      },
      56: {
        inputs: {
          boolean: true,
          on_true: [
            '55',
            0
          ],
          on_false: [
            '54',
            0
          ]
        },
        class_type: 'easy ifElse',
        _meta: {
          title: 'If else'
        }
      }
    }
    const clientId = uuidv4()
    const data = {
      prompt: promptData,
      client_id: clientId
    }
    // 发送 Prompt 请求
    const sendPromptRequest = async () => {
      try {
        console.log('get prompt response', data)
        return genPrompt(data)
      } catch (error) {
        console.error('发送作图请求失败：', error)
      }
    }

    const fetchImageFilename = async (promptId) => {
      try {
        // 直接使用该实例请求历史记录
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        const promptIndex = 2 // prompt信息的下标
        const temp = []
        if (promptInfo.status.status_str === 'success') {
          for (let i = 48; i < 52; i++) {
            temp.push(JSON.parse(promptInfo.prompt[promptIndex][i].inputs.filename)[0])
          }
          temp.forEach(async (item) => {
            const imagepath = genOssImage(item)
            imageList.push(imagepath)
          })
        } else {
          console.error('获取历史记录失败，状态码：', response.status)
        }
        return imageList
      } catch (error) {
        console.error('获取图像文件名失败：', error)
      }
    }

    const listenToProgress = (promptId) => {
      const ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        ws.close()
      }, 2000)

      ws.onopen = () => {
        console.log('提交服务器开始生成...')
        clearTimeout(wsTimeout)
      }
      ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(event.data)
            if (msg.type === 'executing') {
              const data = msg.data
              if (data.node === null && data.prompt_id === promptId) {
                ws.close()
                const images = await fetchImageFilename(promptId)
                // 返回对象
                const obj = {
                  images: images,
                  status: false
                }
                resolve(obj)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              if (progressCallback && typeof progressCallback === 'function') {
                progressCallback(current)
              }
            }
          } catch (error) {
            console.log('获取结果失败，请重试')
          }
        }
      }
      ws.onerror = (error) => {
        reject(error)
      }
      ws.onclose = async () => {
        try {
          const index = cudaIndexNum()
          await cuda.changeCudaCurrentStatus(index, 'leisure')
        } catch (error) { console.log(error) }
      }
    }

    (async () => {
      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    })()
  })
}

export {
  fluxImageGen
}
